module.exports = __webpack_public_path__ + "static/media/ODS17.c87de2b4.svg";